/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep } from 'lodash';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import DatetimePicker from 'shared/ui/components/form-components/pickers/DatetimePicker.vue';
import DateFormatsInfoModal from 'shared/ui/components/modals/DateFormatsInfoModal.vue';

const __vue_script__ = {
    name: 'DatetimeConfigModal',

    components: { BaseInput, BaseSelect, Toggler, DatetimePicker },

    props: {
        event: {
            type: Object,
            required: true
        },

        saveCallback: {
            type: Function,
            required: true
        },

        name: {
            type: String,
            default: null
        },

        value: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        const dateFormatPresets = [{
            value: this.$const.DEFAULT_DATE_FORMAT,
            label: this.$const.DEFAULT_DATE_FORMAT
        }, {
            value: 'DD-MM-YYYY',
            label: 'DD-MM-YYYY'
        }, {
            value: 'MM-DD-YYYY',
            label: 'MM-DD-YYYY'
        // We comment this out until this becomes a requirement,
        // or when we move this tool inside the metadata editor;
        // which comes first.
        // }, {
        //     value: 'custom',
        //     label: this.$t('general.custom')
        }];

        const timeFormatPresets = [{
            value: this.$const.DEFAULT_TIME_FORMAT,
            label: this.$const.DEFAULT_TIME_FORMAT
        }, {
            value: 'H:mm',
            label: 'H:mm'
        }, {
            value: 'h:mm A',
            label: 'h:mm A'
        // See dateFormatPresets comment.,
        // }, {
        //     value: 'custom',
        //     label: this.$t('general.custom')
        }];

        return {
            valid: false,
            datesRange: [],
            timesRange: [],
            enableDatesRange: false,
            enableTimesRange: false,
            datesEnabled: true,
            timesEnabled: false,
            dateFormat: null,
            timeFormat: null,
            dateFormatPreset: dateFormatPresets[0],
            dateFormatPresets,
            timeFormatPreset: timeFormatPresets[0],
            timeFormatPresets,
        };
    },

    computed: {
        dates: {
            get() { return this.datesRange; },
            set(value) { this.datesRange = value.filter(Boolean); }
        },

        times: {
            get() { return this.timesRange; },
            set(value) { this.timesRange = value.filter(Boolean); }
        }
    },

    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(value) {
                this.setInitialData(value);
            }
        },

        dateFormatPreset() {
            // This is always true, but we keep it awaiting
            // for the day we move this tool inside the metadata editor.
            if (this.dateFormatPreset && this.dateFormatPreset?.value !== 'custom') {
                this.dateFormat = this.dateFormatPreset.value;
            }
        },

        timeFormatPreset() {
            // This is always true, but we keep it awaiting
            // for the day we move this tool inside the metadata editor.
            if (this.timeFormatPreset && this.timeFormatPreset?.value !== 'custom') {
                this.timeFormat = this.timeFormatPreset.value;
            }
        },

        enableDatesRange() {
            if (!this.enableDatesRange) {
                this.dates = [];
            }
        },

        enableTimesRange() {
            if (!this.enableTimesRange) {
                this.times = [];
            }
        }
    },

    methods: {
        setInitialData(value) {
            const val = cloneDeep((value || this.value).kind_options || {});

            this.dateFormat = val.date_format || this.$const.DEFAULT_DATE_FORMAT;
            this.datesRange = (val.dates || []).filter(Boolean);
            this.datesEnabled = val.dates_enabled !== false;
            this.enableDatesRange = this.datesRange.length > 0;
            this.timeFormat = val.time_format || this.$const.DEFAULT_TIME_FORMAT;
            this.timesRange = (val.times || []).filter(Boolean);
            this.timesEnabled = val.times_enabled;
            this.enableTimesRange = this.timesRange.length > 0;

            this.dateFormatPreset = this.dateFormatPresets.find(preset => preset.value === this.dateFormat) || this.dateFormatPresets.find(p => p.value === 'custom');
            this.timeFormatPreset = this.timeFormatPresets.find(preset => preset.value === this.timeFormat) || this.timeFormatPresets.find(p => p.value === 'custom');
        },

        submit() {
            this.valid = true;
            this.saveCallback({
                date_format: this.dateFormat,
                dates: this.dates,
                dates_enabled: this.datesEnabled,
                name: this.name,
                removable: true,
                time_format: this.timeFormat,
                times: this.times,
                times_enabled: this.timesEnabled,
            });
            this.$emit('close');
        },

        showDateFormatInfo(type) {
            this.$modal.show(DateFormatsInfoModal, { type }, {
                classes: 'small',
                height: 'auto',
                reset: true
            });
        },

        cancel() {
            this.setInitialData();
            this.$nextTick(async () => {
                const valid = await this.$refs.form.validate(true);
                if (!valid) {
                    this.saveCallback(false);
                    this.$emit('close');
                } else {
                    this.$emit('close');
                }
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "form",
    attrs: { slim: true },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var handleSubmit = ref.handleSubmit
          return [
            _c(
              "form",
              {
                staticClass: "datetime-config-modal modal-wrapper",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.submit)
                  },
                },
              },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "registration.configuration.form.datetime_config.title"
                        )
                      )
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("validation-provider", {
                      attrs: {
                        rules: "required_if:timesEnabled,false",
                        slim: true,
                        vid: "datesEnabled",
                        name: _vm.$t(
                          "registration.configuration.form.datetime_config.dates_range"
                        ),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("toggler", {
                                  attrs: {
                                    name: "datesEnabled",
                                    "off-label": _vm.$t(
                                      "registration.configuration.form.datetime_config.enable_dates"
                                    ),
                                    "on-label": _vm.$t(
                                      "registration.configuration.form.datetime_config.enable_dates"
                                    ),
                                    errors: errors,
                                  },
                                  model: {
                                    value: _vm.datesEnabled,
                                    callback: function ($$v) {
                                      _vm.datesEnabled = $$v
                                    },
                                    expression: "datesEnabled",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm.datesEnabled
                      ? _c(
                          "div",
                          { staticClass: "feature-dependant" },
                          [
                            _c("base-select", {
                              attrs: {
                                name: "dateFormatOpt",
                                "allow-empty": false,
                                label: _vm.$t(
                                  "registration.configuration.form.datetime_config.format"
                                ),
                                options: _vm.dateFormatPresets,
                              },
                              model: {
                                value: _vm.dateFormatPreset,
                                callback: function ($$v) {
                                  _vm.dateFormatPreset = $$v
                                },
                                expression: "dateFormatPreset",
                              },
                            }),
                            _vm.dateFormatPreset &&
                            _vm.dateFormatPreset.value === "custom"
                              ? _c(
                                  "div",
                                  { staticClass: "feature-dependant" },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        slim: true,
                                        name: _vm
                                          .$t(
                                            "registration.configuration.form.datetime_config.format"
                                          )
                                          .toLowerCase(),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("base-input", {
                                                  staticClass: "format-input",
                                                  attrs: {
                                                    name: "dateFormat",
                                                    label: _vm.$t(
                                                      "registration.configuration.form.datetime_config.format"
                                                    ),
                                                    errors: errors,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "inside-label",
                                                        fn: function (ref) {
                                                          return [
                                                            _c("i", {
                                                              staticClass:
                                                                "tip ic-info-fill",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showDateFormatInfo(
                                                                      "date"
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.dateFormat,
                                                    callback: function ($$v) {
                                                      _vm.dateFormat = $$v
                                                    },
                                                    expression: "dateFormat",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("toggler", {
                              attrs: {
                                name: "enableDatesRange",
                                "off-label": _vm.$t(
                                  "registration.configuration.form.datetime_config.dates"
                                ),
                                "on-label": _vm.$t(
                                  "registration.configuration.form.datetime_config.dates"
                                ),
                              },
                              model: {
                                value: _vm.enableDatesRange,
                                callback: function ($$v) {
                                  _vm.enableDatesRange = $$v
                                },
                                expression: "enableDatesRange",
                              },
                            }),
                            _vm.enableDatesRange
                              ? _c(
                                  "div",
                                  { staticClass: "feature-dependant" },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        slim: true,
                                        name: "dates",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("datetime-picker", {
                                                  attrs: {
                                                    name: "dates",
                                                    type: "date",
                                                    clearable: true,
                                                    errors: errors,
                                                    format: _vm.dateFormat,
                                                    range: true,
                                                    timezone:
                                                      _vm.event.timezone,
                                                    "value-type":
                                                      _vm.$const
                                                        .DEFAULT_DATE_FORMAT,
                                                  },
                                                  model: {
                                                    value: _vm.dates,
                                                    callback: function ($$v) {
                                                      _vm.dates = $$v
                                                    },
                                                    expression: "dates",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("validation-provider", {
                      attrs: {
                        rules: "required_if:datesEnabled,false",
                        slim: true,
                        vid: "timesEnabled",
                        name: _vm.$t(
                          "registration.configuration.form.datetime_config.time_range"
                        ),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("toggler", {
                                  attrs: {
                                    name: "timesEnabled",
                                    "off-label": _vm.$t(
                                      "registration.configuration.form.datetime_config.enable_times"
                                    ),
                                    "on-label": _vm.$t(
                                      "registration.configuration.form.datetime_config.enable_times"
                                    ),
                                    errors: errors,
                                  },
                                  model: {
                                    value: _vm.timesEnabled,
                                    callback: function ($$v) {
                                      _vm.timesEnabled = $$v
                                    },
                                    expression: "timesEnabled",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm.timesEnabled
                      ? _c(
                          "div",
                          { staticClass: "feature-dependant" },
                          [
                            _c("base-select", {
                              attrs: {
                                name: "timeFormatOpt",
                                "allow-empty": false,
                                label: _vm.$t(
                                  "registration.configuration.form.datetime_config.time_format"
                                ),
                                options: _vm.timeFormatPresets,
                              },
                              model: {
                                value: _vm.timeFormatPreset,
                                callback: function ($$v) {
                                  _vm.timeFormatPreset = $$v
                                },
                                expression: "timeFormatPreset",
                              },
                            }),
                            _vm.timeFormatPreset &&
                            _vm.timeFormatPreset.value === "custom"
                              ? _c(
                                  "div",
                                  { staticClass: "feature-dependant" },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        slim: true,
                                        name: "timeFormat",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("base-input", {
                                                  staticClass: "format-input",
                                                  attrs: {
                                                    name: "timeFormat",
                                                    label: _vm.$t(
                                                      "registration.configuration.form.datetime_config.time_format"
                                                    ),
                                                    errors: errors,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "inside-label",
                                                        fn: function (ref) {
                                                          return [
                                                            _c("i", {
                                                              staticClass:
                                                                "tip ic-info-fill",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showDateFormatInfo(
                                                                      "time"
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.timeFormat,
                                                    callback: function ($$v) {
                                                      _vm.timeFormat = $$v
                                                    },
                                                    expression: "timeFormat",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("footer", { staticClass: "actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: { type: "button" },
                        on: { click: _vm.cancel },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                    ),
                    _c("button", { staticClass: "btn btn-primary" }, [
                      _vm._v(_vm._s(_vm.$t("general.save"))),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/registrations/DatetimeConfigModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__